import { Card, Stack } from '@mui/material';
import { useState } from 'react';
import ItemImage from './item-image';

export type ItemImageGalleryProps = {
  itemId: string;
  imageCount: number;
};

export default function ItemImageGallery(props: ItemImageGalleryProps) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = Array(props.imageCount).fill(0, 0, props.imageCount);

  return (
    <Stack direction={'column'} useFlexGap gap={3}>
      <Card style={{ background: '#FCFBFC' }}>
        <ItemImage
          scale={8}
          height={60}
          itemId={props.itemId}
          imageNumber={currentImageIndex}
        />
      </Card>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', columnGap: '10px' }}>
        {images.map((_, idx) => (
          <div
            role='button'
            onClick={() => setCurrentImageIndex(idx + 1)}
            style={{
              display: 'block',
              width: '100%',
              height: '100%',
              flexGrow: 0,
              flexShrink: 1,
            }}
          >
            <Card>
              <ItemImage
                itemId={props.itemId}
                imageNumber={idx + 1}
                scale={2}
                height={40}
              />
            </Card>
          </div>
        ))}
      </div>
    </Stack>
  );
}
